export default __webpack_public_path__ + "static/HomeBG1-b856d5862d91640794e19e4740a6b58c.png";